import U from '../../common/ticket_stub/ticket_stub_utils';
import get from 'lodash/get';

export function hasTickets (basket) {
  const seatingTickets = Object.keys(basket.activeSeats);
  const GATickets = Object.keys(basket.GASeats);

  return !!(seatingTickets.length || GATickets.length);
}

export function getTicketPrice (seat, prices) {
  if (!seat || !prices || !Array.isArray(prices)) return {};

  const result = prices.filter(makeIsPriceMatchFunc(seat))[0];
  return result || {};
}

function makeIsPriceMatchFunc (seat) {
  return function (price) {
    return price.priceCategory === seat.priceCategory && price.priceType === seat.priceType;
  };
}

export function activeSeatsToTicketDataArray (activeSeats, priceTypes, prices) {
  if (!activeSeats || !priceTypes) return [];

  return Object.keys(activeSeats)
    .map(key => Object.assign({id: key, ...activeSeats[key]}))
    .map(seat => activeSeatToTicketData(seat, priceTypes, prices));
}

export function activeSeatToTicketData (activeSeat, priceTypes, prices) {
  const template = {
    seat_name: {},
    price: getTicketPrice(activeSeat, prices)
  };

  if (!activeSeat || !priceTypes) return template;

  template.seat_name[U.TYPE] = get(priceTypes, `[${activeSeat.priceType}].name`, '');
  template.seat_name[U.LEVEL] = get(activeSeat, 'level', '');
  template.seat_name[U.SECTION] = get(activeSeat, 'section', '');
  template.seat_name[U.ROW] = get(activeSeat, 'row', '');
  template.seat_name[U.SEAT] = get(activeSeat, 'seat', '');

  template.id = get(activeSeat, 'id', '');

  return template;
}

function gaSeatsToGaPriceTypes (gaSeats) {
  if (!gaSeats) return [];

  const sections = Object.keys(gaSeats);
  return sections.reduce((acc, key) => gaSectionToPriceTypes(acc, gaSeats[key]), []);
}

function gaSectionToPriceTypes (acc, section) {
  return acc.concat(gaPriceCategoriesToGaPriceTypes(section));
}

function gaPriceCategoriesToGaPriceTypes (gaPriceCategories) {
  if (!gaPriceCategories) return [];

  const categories = Object.keys(gaPriceCategories);
  return categories.reduce((acc, key) => categoryToPriceTypes(acc, gaPriceCategories[key]), []);
}

function categoryToPriceTypes (acc, category) {
  return acc.concat(gaPriceTypesToArray(category));
}

function gaPriceTypesToArray (priceTypes) {
  if (!priceTypes) return [];

  const keys = Object.keys(priceTypes);
  return keys.reduce((acc, key) => expandGaPriceType(acc, priceTypes[key]), []);
}

function expandGaPriceType (acc, priceType) {
  for (var i = 0; i < priceType.qty; i++) {
    acc.push(priceType);
  }
  return acc;
}

export function gaSeatsToGaTicketdataArray (gaSeats, priceTypes) {
  if (!gaSeats) return [];

  const gaPriceTypes = gaSeatsToGaPriceTypes(gaSeats);
  return gaPriceTypes.map(gaPriceType => gaPriceTypeToGaTicketdataArray(gaPriceType, priceTypes));
}

function gaPriceTypeToGaTicketdataArray (gaPriceType, priceTypes) {
  const priceType = get(gaPriceType, 'price.priceType', '');
  const priceCategoryId = get(gaPriceType, 'priceCategoryId', '');
  const template = {
    seat_name: {},
    price: get(gaPriceType, 'price', {}),
    priceCategoryId: priceCategoryId,
    priceType: priceType,
    section: get(gaPriceType, 'section'),
    id: `${priceType}-${priceCategoryId}`
  };

  if (!gaPriceType || !priceTypes) return template;

  template.seat_name[U.TYPE] = get(priceTypes, `[${priceType}].name`, '');
  template.seat_name[U.LEVEL] = get(gaPriceType, 'level', '');
  template.seat_name[U.SECTION] = get(gaPriceType, 'sectionName', '');

  return template;
}

export default {
  gaSeatsToGaTicketdataArray,
  getTicketPrice,
  activeSeatsToTicketDataArray,
  activeSeatToTicketData,
  hasTickets
};



// WEBPACK FOOTER //
// ./frontend/react/components/edp/basket/basket_utils.js